<template>
	<div class="case-attachment card">
		<div>
			<div class="mobile-text">
				<div class="header4">Attachments</div>
				<div class="paragraph">
					Please Upload each of the previos documents as indicated. You can drag and drop the file or browse to find your files. Format must
					be PDF.
				</div>
			</div>
			<div class="drag-drop-cont">
				<DragAndDrop />
				<DragAndDrop />
				<DragAndDrop />
				<DragAndDrop />
			</div>
		</div>
		<div class="all-files">
			<div class="header5">View all</div>
		</div>
	</div>
</template>

<script>
import DragAndDrop from "@/components/ui/DragAndDrop.vue";

export default {
	name: "case-attachment",
	components: {
		DragAndDrop,
	},
	props: {
		id: Number,
	},
	data() {
		return {
			date: new Date(),
		};
	},
};
</script>

<style scoped lang="scss">
.case-attachment {
	padding: 25px;
	text-align: left;
	display: flex;
	flex-direction: column;
	.mobile-text {
		display: none;
	}
	.header4 {
		color: var(--dark-gray);
		margin-bottom: 15px;
	}
	.paragraph {
		color: var(--dark-gray);
		margin-top: 15px;
		opacity: 0.5;
	}
	.drag-drop-cont {
		margin-top: 20px;
	}
	.drag-drop-cont > div {
		margin-bottom: 15px;
	}
	.all-files {
		border-top: 2px solid #f4f4f4;
		margin-top: 45px;
		padding-top: 30px;
		text-align: center;
		.header5 {
			color: var(--dark-gray);
		}
	}
	@media screen and (max-width: 414px) {
		.drag-drop-cont {
			margin: 20px auto;
		}
		.mobile-text {
			display: block;
		}
	}
}
</style>
